import { createSlice } from "@reduxjs/toolkit";
import { fetchCountry, fetchGenders, fetchTranslation, fetchUserById, fetchUserModule } from "./thunk";

const moduleSlice = createSlice({
  name: "module",
  initialState: {
    module: [],
    genders: [],
    country: [],
    translations: '',
    translationLoading: false, // Add this line
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Get All Page permission
      .addCase(fetchUserModule.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserModule.fulfilled, (state, action) => {
        state.loading = false;
        state.module = action.payload;
      })
      .addCase(fetchUserModule.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Genders
      .addCase(fetchGenders.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchGenders.fulfilled, (state, action) => {
        state.genders = action.payload;
      })
      .addCase(fetchGenders.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Get All Country
      .addCase(fetchCountry.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchCountry.fulfilled, (state, action) => {
        state.country = action.payload;
      })
      .addCase(fetchCountry.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Fetch Translation
      .addCase(fetchTranslation.pending, (state) => {
        state.translationLoading = true; // Set loading to true
        state.error = null;
      })
      .addCase(fetchTranslation.fulfilled, (state, action) => {
        state.translationLoading = false; // Set loading to false
        state.translations = action.payload;
      })
      .addCase(fetchTranslation.rejected, (state, action) => {
        state.translationLoading = false; // Set loading to false
        state.error = action.payload;
      });

  },
});

export default moduleSlice.reducer;
